/**
 * @generated SignedSource<<338d177b3fccfa2dfaacfb3dd1775e1b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type UserStatus = "ACTIVE" | "DEACTIVATED" | "SUSPENDED" | "%future added value";
export type UserType = "ADMIN" | "BLOCKED" | "EXTERNAL_USER" | "INTERNAL_USER" | "REVIEWER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CompanyUserTablePaginationFragment_gwtUsers$data = {
  readonly gwtUsers: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly firstName: string;
        readonly jobTitle: string | null | undefined;
        readonly lastName: string;
        readonly rowId: UUID;
        readonly status: UserStatus;
        readonly userType: UserType;
        readonly " $fragmentSpreads": FragmentRefs<"UserCertificationsDisplay">;
      };
    }>;
    readonly totalCount: number;
  } | null | undefined;
  readonly " $fragmentType": "CompanyUserTablePaginationFragment_gwtUsers";
};
export type CompanyUserTablePaginationFragment_gwtUsers$key = {
  readonly " $data"?: CompanyUserTablePaginationFragment_gwtUsers$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompanyUserTablePaginationFragment_gwtUsers">;
};

import CompanyUserTablePaginationQuery_Refetchable_graphql from './CompanyUserTablePaginationQuery_Refetchable.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "gwtUsers"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "gwtUserFilter"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "gwtUsersOrderBy"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": CompanyUserTablePaginationQuery_Refetchable_graphql
    }
  },
  "name": "CompanyUserTablePaginationFragment_gwtUsers",
  "selections": [
    {
      "alias": "gwtUsers",
      "args": [
        {
          "kind": "Variable",
          "name": "filter",
          "variableName": "gwtUserFilter"
        },
        {
          "kind": "Variable",
          "name": "orderBy",
          "variableName": "gwtUsersOrderBy"
        }
      ],
      "concreteType": "GwtUsersConnection",
      "kind": "LinkedField",
      "name": "__CompanyUserTable_gwtUsers_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GwtUsersEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GwtUser",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "rowId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "userType",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "UserCertificationsDisplay"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "jobTitle",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "status",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "1af9f21b6c2a4563d76df5a6c010a261";

export default node;
